// event routes constants
export const ROUTES_EVENT = 'event';
export const ROUTES_EVENT_OVERVIEW = 'event-overview';
export const ROUTES_EVENT_ATTENDANCE = 'event-attendance';

export const ROUTES_EQUIPMENT = 'equipment';
export const ROUTES_EQUIPMENT_LIST = 'equipment-list';
export const ROUTES_EQUIPMENT_LIST_FORM_CATEGORY = 'equipment-list-form-category';
export const ROUTES_EQUIPMENT_LIST_FORM_EQUIPMENT = 'equipment-list-form-equipment';
export const ROUTES_EQUIPMENT_LIST_ITEM_LOGS = 'equipment-list-item-logs';

// session routes constants
export const ROUTES_SESSION_OVERVIEW = 'session-overview';
export const ROUTES_SESSION_ATTENDANCE = 'session-attendance';
export const ROUTES_SESSION_RESULTS = 'session-results';
export const ROUTES_SESSION_TELEMETRY = 'session-telemetry';
export const ROUTES_SESSION_RESULTS_LIVE = 'session-results-live';
export const ROUTES_SESSION_CREWS = 'session-crews';
export const ROUTES_SESSION_IMPORTS = 'session-imports';
export const ROUTES_SESSION_IMPORT_FILE = 'session-import-file';

// profile
export const ROUTES_PROFILE = 'profile';
export const ROUTES_PROFILE_DRV = 'profile-drv';
export const ROUTES_PROFILE_MORNING_MONITORING = 'profile-morning-monitoring';
export const ROUTES_PROFILE_NOTES = 'profile-notes';
export const ROUTES_PROFILE_OVERVIEW = 'profile-overview';
export const ROUTES_PROFILE_REPORT_BIKE = 'profile-report-bike';
export const ROUTES_PROFILE_REPORT_ERGO = 'profile-report-ergo';
export const ROUTES_PROFILE_REPORT_ROWING = 'profile-report-rowing';
export const ROUTES_PROFILE_REPORT_TRAINING_SUMMARY = 'profile-report-training-summary';
export const ROUTES_PROFILE_SETTINGS = 'profile-settings';
export const ROUTES_PROFILE_ATHLETE_LIST = 'profile-athlete-list';

export const ROUTES_CALENDAR = 'calendar';

// challenges
export const ROUTES_CHALLENGE_TEAM_FORM = 'challenge-team-form';
export const ROUTES_CHALLENGE = 'challenge';
export const ROUTES_CHALLENGES = 'challenges';
export const ROUTES_CHALLENGES_PUBLIC = 'challenges-public';
export const ROUTES_CHALLENGE_SINGLE_PUBLIC = 'challenge-single-public';
export const ROUTES_CHALLENGE_CREATE = 'challenge-create';

export const ROUTES_HOME = 'home';
export const ROUTES_SQUADS = 'squads';
export const ROUTES_SQUADS_MAIN = 'squads-main';
export const ROUTES_SQUADS_LEAVE = 'squads-leave';

export const ROUTES_STYLEGUIDE = 'styleguide';

export const ROUTES_CREWS_LIST = 'crews-list';
export const ROUTES_CLUB_MEMBERS = 'club-members';

// reports
export const ROUTES_REPORTS = 'reports';
export const ROUTES_REPORTS_ATTENDANCE = 'reports-attendance';
export const ROUTES_REPORTS_GMT = 'reports-gmt';
export const ROUTES_REPORTS_MORNING_MONITORING = 'reports-morning-monitoring';
export const ROUTES_REPORTS_MM_DAILY = 'reports-morning-monitoring-daily';
export const ROUTES_REPORTS_MM_INJURY_ILLNESS = 'reports-morning-monitoring-injury-illness';
export const ROUTES_REPORTS_MM_TRAINING_QUALITY = 'reports-morning-monitoring-training-quality';
export const ROUTES_REPORTS_RPE = 'reports-rpe';
export const ROUTES_REPORTS_TEAM_ERGO = 'reports-team-ergo';
export const ROUTES_REPORTS_TEAM_TRAINING_SUMMARY = 'reports-team-training-summary';
export const ROUTES_REPORTS_TRAINING_SUMMARY = 'reports-training-summary';
export const ROUTES_REPORTS_COMPARISON = 'reports-comparison';

// DRV reports
export const ROUTES_REPORTS_STEP_TEST_GROUP = 'reports-step-test-group';
export const ROUTES_REPORTS_STEP_TEST_INDIVIDUAL = 'reports-step-test-individual';
export const ROUTES_REPORTS_VO2_TEST_GROUP = 'reports-vo2-test-group';
export const ROUTES_REPORTS_VO2_TEST_INDIVIDUAL = 'reports-vo2-test-individual';
export const ROUTES_REPORTS_2K_TEST_GROUP = 'reports-2k-test-group';
export const ROUTES_REPORTS_2K_TEST_INDIVIDUAL = 'reports-2k-test-individual';
export const ROUTES_REPORTS_6K_TEST_GROUP = 'reports-6k-test-group';
export const ROUTES_REPORTS_6K_TEST_INDIVIDUAL = 'reports-6k-test-individual';
export const ROUTES_REPORTS_5K_TEST_GROUP = 'reports-5k-test-group';
export const ROUTES_REPORTS_5K_TEST_INDIVIDUAL = 'reports-5k-test-individual';

// AUS reports
export const ROUTES_REPORTS_RACING_REPORT = 'reports-racing';
export const ROUTES_REPORTS_RACING_MULTIPLE_CREWS_MULTIPLE_PIECES = 'reports-racing-multiple-crews-multiple-pieces';
export const ROUTES_REPORTS_RACING_MULTIPLE_CREWS_MULTIPLE_SESSIONS = 'reports-racing-multiple-crews-multiple-sessions';
export const ROUTES_REPORTS_RACING_MULTIPLE_CREWS_SINGLE_PIECE = 'reports-racing-multiple-crews-single-piece';
export const ROUTES_REPORTS_RACING_SINGLE_CREW_SESSION_PIECES = 'reports-racing-single-crew-session-pieces';
export const ROUTES_REPORTS_RACING_SINGLE_CREW_SINGLE_SESSION = 'reports-racing-single-crew-single-session';

// live
export const ROUTES_LIVE_ALL_SESSIONS = 'live-all-sessions';
export const ROUTES_LIVE_SINGLE_SESSION = 'live-single-session';

// authorization
export const ROUTES_LOGIN = 'login';
export const ROUTES_FORGOT_PASSWORD = 'forgot-password';
export const ROUTES_SIGN_UP_SUCCESS = 'sign-up-success';
export const ROUTES_LOGOUT = 'logout';
export const ROUTES_RESEND_ACTIVATION_EMAIL = 'resend-activation-email';

// new onboarding
export const ROUTES_ACTIVATE_ACCOUNT = 'activate-account';
export const ROUTES_ACTIVATE_ACCOUNT_CLUB = 'activate-account:club';
export const ROUTES_ACTIVATE_ACCOUNT_FINAL = 'activate-account:final';

// search
export const ROUTES_SEARCH_RESULTS = 'search-results';

// billing
export const ROUTES_BILLING = 'billing';
export const ROUTES_BILLING_LICENCE_EXPIRED = 'billing-licence-expired';

// settings
export const ROUTES_SETTINGS_ACCOUNT = 'settings-account';
export const ROUTES_SETTINGS_INTEGRATIONS = 'settings-integrations';
export const ROUTES_SETTINGS_INTEGRATIONS_POLAR = 'settings-integrations-polar';
export const ROUTES_SETTINGS_INTEGRATIONS_SUUNTO = 'settings-integrations-suunto';
export const ROUTES_SETTINGS_INTEGRATIONS_GARMIN_PUSH = 'settings-integrations-garmin-push';
export const ROUTES_SETTINGS_INTEGRATIONS_STRAVA = 'settings-integrations-strava';
export const ROUTES_SETTINGS_MY_CLUBS = 'settings-my-clubs';
export const ROUTES_SETTINGS_PRIVACY_SETTINGS = 'settings-privacy-settings';

export const ROUTES_UPGRADE_TO_PERFORMANCE = 'upgrade-to-performance';

export const ROUTES_WELCOME = 'welcome';

// invitation
export const ROUTES_INVITATION_FOR_MEMBERSHIP = 'invitation-for-membership';
export const ROUTES_INVITATION_FOR_MEMBERSHIP_ACCEPT = 'invitation-for-membership-accept';
export const ROUTES_INVITATION_FOR_MEMBERSHIP_REJECT = 'invitation-for-membership-reject';
export const ROUTES_ADD_MEMBER = 'add-member';
export const ROUTES_UPLOAD_SESSION_FILES = 'upload-session-files';

// notifications
export const ROUTES_NOTIFICATION_SETTINGS = 'notification-settings';
export const ROUTES_NOTIFICATIONS = 'notifications';

// ex modals routes
export const ROUTES_CREATE_SESSION = 'create-session';
export const ROUTES_ADD_RESULTS = 'add-results';
export const ROUTES_SQUAD_FORM = 'squad-form';
export const ROUTES_EDIT_CLUB_MEMBER_ROLES = 'edit-member-roles';

export const ROUTES_CREATE_CLUB = 'create-club';
export const ROUTES_EDIT_CLUB = 'edit-club';

export const ROUTES_HANDLE_PAYMENT = 'handle-payment';
export const ROUTES_SWITCH_CLUB = 'switch-club';
export const ROUTES_UNAUTHORIZED = 'unauthorized';

export const ROUTES_ADMIN = {
    ADMIN: 'admin',
    DASHBOARD: 'admin-dashboard',
    USERS: 'admin-users',
    CLUBS: 'admin-clubs',
    CREATE_CLUB: 'admin-create-club',
    EDIT_CLUB: 'admin-edit-club',
    USER_FORM: 'admin-user-form'
};

// public live
export const ROUTES_PUBLIC_LIVE = 'public-live';
export const ROUTES_PUBLIC_LIVE_ADMIN = 'public-live-admin';
export const ROUTES_PUBLIC_LIVE_STATISTIC = 'public-live-statistic';
export const ROUTES_PUBLIC_LIVE_STATISTIC_CREW = 'public-live-statistic-crew';
export const ROUTES_PUBLIC_LIVE_STATISTIC_CREW_STROKE_RATE = 'public-live-statistic-crew:stroke-rate';
export const ROUTES_PUBLIC_LIVE_STATISTIC_CREW_DISTANCE = 'public-live-statistic-crew:distance';
export const ROUTES_PUBLIC_LIVE_STATISTIC_CREW_PACE = 'public-live-statistic-crew:pace';
export const ROUTES_PUBLIC_LIVE_STATISTIC_CREWS = 'public-live-statistic-crews';
export const ROUTES_PUBLIC_LIVE_STATISTIC_TIME = 'public-live-statistic:time';
export const ROUTES_PUBLIC_LIVE_STATISTIC_CREWS_RATE_PACE = 'public-live-statistic-crews:crews-rate-pace';
export const ROUTES_PUBLIC_LIVE_STATISTIC_CREWS_REVERSE_RATE_PACE =
    'public-live-statistic-crews:crews-reverse-rate-pace';
